import React, { useEffect, useState } from 'react';
import millify from 'millify';
import { Link } from 'react-router-dom';
import { Card, Row, Col, Input } from 'antd';
import { useGetCryptosQuery } from '../services/cryptoApi';
import Loader from './Loader';

const Cryptocurrencies = ({ simplified }) => {
    const count = simplified ? 10 : 100;
    const { data: cryptosList, isFetching } = useGetCryptosQuery(count);
    const [cryptos, setCryptos] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        setCryptos(cryptosList?.data?.coins || []);
    }, [cryptosList]);

    useEffect(() => {
        if (cryptosList?.data?.coins) {
            const filteredData = cryptosList.data.coins.filter((item) =>
                item.name.toLowerCase().includes(searchTerm)
            );
            setCryptos(filteredData);
        }
    }, [searchTerm, cryptosList]);

    if (isFetching) return <Loader />;

    const containerStyle = {
        backgroundColor: '#1a1a1a',
        color: '#fff',
        padding: '1rem',
    };

    const searchStyle = {
        marginBottom: '1rem',
        display: 'flex',
        justifyContent: 'center',
    };

    const inputStyle = {
        width: '100%',
        maxWidth: '400px',
        borderRadius: '5px',
        border: '1px solid #333',
        backgroundColor: '#333',
        color: '#fff',
    };

    const cardStyle = {
        backgroundColor: '#2a2a2a',
        color: '#fff',
        borderRadius: '10px',
        overflow: 'hidden',
    };

    const cardExtraStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    };

    const cryptoImageStyle = {
        width: '40px',
        height: '40px',
    };

    return (
        <div style={containerStyle}>
            {!simplified && (
                <div style={searchStyle}>
                    <Input
                        placeholder="Search Cryptocurrency"
                        onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
                        style={inputStyle}
                    />
                </div>
            )}
            <Row gutter={[32, 32]} className="crypto-card-container">
                {cryptos?.map((currency) => (
                    <Col
                        xs={24}
                        sm={12}
                        lg={6}
                        className="crypto-card"
                        key={currency.uuid}
                    >
                        <Link to={`/crypto/${currency.uuid}`}>
                            <Card
                                title={`${currency.rank}. ${currency.name}`}
                                extra={<img style={cryptoImageStyle} src={currency.iconUrl} alt={currency.name} />}
                                hoverable
                                style={cardStyle}
                            >
                                <p>Price: {millify(currency.price)}</p>
                                <p>Market Cap: {millify(currency.marketCap)}</p>
                                <p>Daily Change: {currency.change}%</p>
                            </Card>
                        </Link>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default Cryptocurrencies;
